import { render, staticRenderFns } from "./tiktok-logs.vue?vue&type=template&id=d605c58c&"
import script from "./tiktok-logs.vue?vue&type=script&lang=js&"
export * from "./tiktok-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports